import { useEffect, useRef } from "react";
import { Modal } from "./Modal";
import styles from "./ConfirmDialog.module.css";

interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: "danger" | "default";
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "default",
  isLoading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const confirmRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    confirmRef.current?.focus();
  }, []);

  return (
    <Modal
      onClose={onCancel}
      preventClose={isLoading}
      labelledBy="confirm-dialog-title"
      className={styles.modal}
    >
      <h2 id="confirm-dialog-title" className={styles.title}>
        {title}
      </h2>
      <p className={styles.message}>{message}</p>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.cancelButton}
          onClick={onCancel}
          disabled={isLoading}
        >
          {cancelLabel}
        </button>
        <button
          ref={confirmRef}
          type="button"
          className={`${styles.confirmButton} ${variant === "danger" ? styles.danger : ""}`}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? "Deleting…" : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
